// extracted by mini-css-extract-plugin
export var bannerContainer = "NewMobileBanner_bannerContainer__ej2jM";
export var closeNewMobileBannerText = "NewMobileBanner_closeNewMobileBannerText__nOU3f";
export var container = "NewMobileBanner_container__b1YTR";
export var description = "NewMobileBanner_description__jEnBY";
export var logoImage = "NewMobileBanner_logoImage__NpfFA";
export var mobileScreenshots = "NewMobileBanner_mobileScreenshots__d6-Ha";
export var openButton = "NewMobileBanner_openButton__kerS8";
export var textContainer = "NewMobileBanner_textContainer__m4w7O";
export var title = "NewMobileBanner_title__J-DjX";